export { default as LoyaltyTextWidget } from './loyalty-text-widget';
